export function RewardsLoadingState() {
    return (
        <div className="w-full min-h-[140px] animate-pulse flex flex-col gap-3">
            <div className="h-4 bg-stone-100 rounded w-1/3" />
            <div className="h-3 bg-stone-100 rounded w-full" />
            <div className="h-3 bg-stone-100 rounded w-full" />
        </div>
    )
}
